import { Box, Theme, Typography } from "@outschool/backpack";
import React from "react";

export default function CardHeading({ title, subtitle = null }: $TSFixMe) {
  return (
    <Box
      flex
      sx={{
        flexDirection: "column-reverse",
        padding: "1em",
        textAlign: "start",
        flex: 3
      }}
    >
      <Typography
        variant="h3"
        sx={(theme: Theme) => ({
          fontFamily: "'Ginto Normal',sans-serif",
          fontSize: `${theme.typography.pxToRem(16)} !important`,
          fontWeight: "fontWeightBold",
          hyphens: "auto"
        })}
      >
        {title}
      </Typography>
      {subtitle && (
        <Typography
          variant="h4"
          sx={(theme: Theme) => ({
            fontFamily: "'Ginto Normal',sans-serif",
            color: "grey.500",
            fontSize: `${theme.typography.pxToRem(12)} !important`,
            paddingBottom: "4px"
          })}
        >
          {subtitle}
        </Typography>
      )}
    </Box>
  );
}
